import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const store = (set) => ({
  logOutTrigger: 0,
  setLogoutTrigger: (logoutTrigger) => set(() => ({ logoutTrigger })),
  clearLogoutTrigger: () => set(() => ({ logoutTrigger: 0 })),
});

export const useLogOutTrigger= create(
  persist(store, {
    name: "logoutTrigger",
    storage: createJSONStorage(() => localStorage), // (optional) by default the 'localStorage' is used
  })
);
